import React, { Component, useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import NavBarMini from './NavBarMini.js';
import LoadingAnimation from './LoadingAnimation';
import { getAuth, signOut, onAuthStateChanged } from "firebase/auth";

import { collection, query, where, getDocs, setDoc, doc } from "firebase/firestore";
import { db } from '../firebase';
import * as utils from '../common/Utils.js'


const Account = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [currentUser, setCurrentUser] = useState({})
  const [dataReady, setDataReady] = useState(false);
  const [currentPlayer, setCurrentPlayer] = useState(null);

  useEffect(() => {
    const auth = getAuth();

    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        setCurrentUser(currentUser)
        getCurrentPlayer(currentUser.email)
      } else {
        setCurrentUser(null)
        navigate('/login', { state: { from: location.pathname } });
      }

      setDataReady(true)
    });

    // Cleanup the listener on unmount
    return () => unsubscribe();
  }, [])

  const getCurrentPlayer = async (email) => {
    const q = query(collection(db, 'players'), where("email", "==", email));
    const snapshot = await getDocs(q);
    const player = snapshot.docs[0]?.data();
    setCurrentPlayer(player);
  }

  const signOutUser = async () => {
    try {
      const auth = getAuth();
      signOut(auth).then(() => {
      })
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  if (dataReady == false || currentUser == null) {
    return (
      <div className="Account">
        <LoadingAnimation />
      </div>
    )
  } else {
    return (
      <div className="Account">
        <div className="league-content">
          <div className='league-body'>
            <div className="account-content">
              <div id="account-header" className="account-section">
                <div className="account-header-intro">
                  { currentPlayer && currentPlayer.firstName ? <h1>Hello { currentPlayer.firstName }!</h1> : <h1>Hello!</h1> }
                  <p>Welcome to the home of basketball in South Boston.</p>
                  { currentPlayer && <a className="btn league-btn-primary" href={ '/players/' + currentPlayer.id }>📊 View my Stats</a> }
                </div>
              </div>
              <div id="account-details" className="account-section">
                <hr></hr>
                <h1>Your profile</h1>

                <div className='account-detail'>
                  { currentPlayer && <><label>Display name:</label> <span>{ currentPlayer.firstName } { currentPlayer.lastName }</span></> }
                </div>
                <div className='account-detail'>
                  <label>Email address:</label> <span>{ currentUser.email }</span>
                </div>
                <div className="account-header-button">
                  <a type="button" className="btn btn-danger" onClick={signOutUser}>Sign Out</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Account;
